let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jvyvi")).then(() => parcelRequire('bVc03'));